import { z } from 'zod';

export const FieldDefinitionsScalarFieldEnumSchema = z.enum(['fieldId','cityId','defaultSet','searchable','sortable','displayable','objectType','objectName','SQLName','description','label','searchOperators','pickList','multiSelectPickList','doTotal','displayOrder','displayGroup','rowTimestamp']);

export default FieldDefinitionsScalarFieldEnumSchema;
